const legrand = require("../../../assets/images/legrand.png");
const iiclipsal = require("../../../assets/images/iiclipsal.png");
const schneider = require("../../../assets/images/schneider.png");
const lawton = require("../../../assets/images/lawton.png");

const partnersLogo = [
  legrand,
  iiclipsal,
  schneider,
  lawton,
];

export default partnersLogo;
